<template>
  <div>
    <v-toolbar class="toobar" :class="{ active: active }">
      <div class="filter d-flex align-items-center">
        <v-btn icon class="icon-btn" @click="closeTag()">
          <img src="img/icons_v2/dropdown-right@3x.png" class="icon-size" />
        </v-btn>
        <label class="t-tag">แท็ก :</label>
        <v-chip-group class="filter-slide">
          <button
            class="btn-first tag-first"
            :class="{ active: activeFirst }"
            @click="selectTagsFirst()"
          >
            <i class="icon-SKUWIN f-45"></i>
            ราคาขาย/แชร์
          </button>
          <button
            v-for="(items, index) in data"
            :key="index"
            type="button"
            class="btn-tags"
            :class="checkSelectTag(items.id) == true ? 'active' : ''"
            @click="selectTag(items)"
          >
            {{ items.name }}
          </button>
        </v-chip-group>
      </div>
    </v-toolbar>
  </div>
</template>

<script>
export default {
  props: ['dataTag', 'statusTags'],

  data() {
    return {
      data: [],
      active: false,
      activeFirst: false,
      dataActive: []
    }
  },

  watch: {
    statusTags(newValue) {
      this.activeFirst = newValue ? true : false
    }
  },

  methods: {
    dataModify() {
      // filter tags to [ props ]
      const tags = this.dataTag.filter((item) => item.id > 0)
      this.data = tags
    },

    selectTagsFirst() {
      this.activeFirst = !this.activeFirst
      this.$emit('selectTagsFirst', this.activeFirst)
    },

    selectTag(item) {
      if (!this.activeFirst) {
        var check = false
        for (const i in this.dataActive) {
          if (this.dataActive[i].id == item.id) {
            check = true
            this.dataActive.splice(i, 1)
          }
        }
        if (check == false) {
          this.dataActive.push(item)
          this.$emit('selectTag', this.dataActive)
        }
      }
    },

    checkSelectTag(id) {
      var check = false
      for (const i in this.dataActive) {
        if (this.dataActive[i].id == id) {
          check = true
        }
      }
      return check
    },

    closeTag() {
      this.active = false
      this.activeFirst = false
      this.$emit('selectTagsFirst', this.activeFirst)

      setTimeout(() => {
        this.$emit('closeTag')
      }, 750)
    },

    activeMenu() {
      this.active = true
    }
  },

  mounted() {
    setTimeout(this.activeMenu, 250)

    this.dataModify()
  }
}
</script>

<style lang="scss" scoped>
.toobar {
  height: 100px !important;
  padding: 20px;
  transform: translateX(100%);
  transition: transform 0.6s ease-out;
  &.active {
    transform: translateX(0);
    transition: transform 0.6s ease;
  }
}
.filter-slide {
  width: 750px;
}

.btn-first {
  width: 100%;
  height: auto;
  margin: 0 5px;
  border-radius: 9px;
  border: solid 1px #cacaca;
  background-color: #eaeaea;
  padding: 10px;
  outline: none;
  color: #a50200;
  &.active {
    background: #fff1f1;
    color: #a50200;
    outline: none;
    border: 1px solid;
  }
  &:focus {
    outline: none;
  }
}

.tag-first {
  display: flex;
  align-items: center;
  background: linear-gradient(0deg, #dedede, #ffffff);
}

.btn-tags {
  width: auto;
  height: auto;
  margin: 0 5px;
  border-radius: 9px;
  border: solid 1px #cacaca;
  background-color: #eaeaea;
  padding: 10px;
  outline: none;
  &:focus {
    outline: none;
  }
  &.active {
    background: #ff811c;
    color: white;
    outline: none;
  }
}
</style>
